import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=7f61d996&"
import script from "./AlertHistory.vue?vue&type=script&lang=js&"
export * from "./AlertHistory.vue?vue&type=script&lang=js&"
import style0 from "./AlertHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports